<template>
  <v-toolbar flat dense class="scanner-header flex-grow-0">
    <v-btn-toggle
      :value="session.scanner_mode"
      mandatory
      dense
      color="primary"
      @change="v => session.setScannerMode(v)"
    >
      <v-btn value="pos" small>
        <v-icon small left>mdi-cash-register</v-icon>
        POS
      </v-btn>
      <v-btn value="storage" small>
        <v-icon small left>mdi-warehouse</v-icon>
        Lager
      </v-btn>
    </v-btn-toggle>

    <v-spacer />

    <slot />

    <v-btn icon small @click="session.signOut()">
      <v-icon small>mdi-logout</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
import { sessionStore } from '@/store/pinia/sessionStore'

export default {
  name: 'ScannerHeader',
  setup() {
    const session = sessionStore()
    return { session }
  },
}
</script>

<style lang="scss" scoped>
.scanner-header {
  border-bottom: thin solid var(--v-border-base, rgba(0, 0, 0, 0.12));
  z-index: 10;
}
</style>
